export default __webpack_public_path__ + "static/media/splash_language.93313327.png";